import React from "react";
import axios from "axios";
import { Checkbox, Button } from "primereact";
import { useToast } from "../../hooks/use-toast";
import { useLanguages } from "../../hooks/use-languages";
import { getCommonParam, languageSupported } from "../../config";

const SupportedLanguages = () => {
  const { toastRef } = useToast();
  const { languages, setLanguages } = useLanguages();
  const apiCommonParam = getCommonParam();
  const { apiUrl, companyId, axiosConfig } = apiCommonParam;

  const handleOnChange = (e) => {
    const value = e.target.value;
    const languageArray = languages.split(",");
    const isLanguagePresent = languageArray.find((lng) => lng === value);
    if (!isLanguagePresent) {
      languageArray.push(value);
      setLanguages(languageArray.join(","));
    } else {
      setLanguages(languageArray.filter((lng) => lng !== value).join(","));
    }
  };

  const saveLanguages = async () => {
    try {
      const param = { id: companyId, lingue: languages };
      const endpoint = `azienda/aggiornalingue`;
      await axios.post(`${apiUrl}${endpoint}`, param, axiosConfig);
      toastRef.current.showToast("success", "Dati salvati correttamente", "");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="px-3">
      <div className="text-600 font-medium text-600 text-xl mb-3">
        <span style={{ color: "black" }}>Lingue Supportate</span>
      </div>
      <div className="surface-card p-2  border-round" />
      <div className="grid formgrid p-fluid">
        <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
        {languageSupported.map((language, index) => (
          <div className="field mb-1 col-12 md:col-12" key={`language-${index}`}>
            <label htmlFor={`label-${language.key}`} className="font-medium text-600">
              <Checkbox
                checked={languages && languages.includes(language.key)}
                disabled={language.default}
                className="mr-4"
                onChange={handleOnChange}
                value={language.key}
              />
              <img src="images/flag_placeholder.png" className={`flag ${language.icon}`} alt="" />
              <span className="px-2">{language.language}</span>
            </label>
          </div>
        ))}
      </div>
      <div className="border-top-1 surface-border pt-3">
        <Button type="button" icon="pi pi-save" label="Salva" onClick={saveLanguages} />
      </div>
    </div>
  );
};

export default SupportedLanguages;
